import React from "react"; 
import { Link } from "react-router-dom";    
import ProductTypesListContent from "../../../components/Dashboard/ProductTypesListContent";

const ProductTypesList = () => {
  return (
    <>
      {/* Breadcrumb */}
      {/* <div className="breadcrumb-card">
        <h5>List of Product Types</h5>

        <ul className="breadcrumb">
          <li>
            <Link to="/dashboard/ecommerce/">
              <i className="material-symbols-outlined">home</i>
              Dashboard
            </Link>
          </li>
          <li>Product Types List</li>
        </ul>
      </div> */}

      <ProductTypesListContent />
    </>
  );
};

export default ProductTypesList;
